'use strict';
var DateTime = require('./DateTime');
var Constants = require('../constants/PensionPaymentConstants');

module.exports = {

	getDatesInAYear: function() {
		var dates = [];
		for(var i=0; i<12; i++) {
			var tempDate = new Date();
			var year = tempDate.getFullYear();
			var month;

			if(tempDate.getMonth()+1+i > 12) {
				month = tempDate.getMonth()+i-11;
				year++;
			} else {
				month = tempDate.getMonth()+1+i;
			}

			dates.push({
				value: DateTime.dateToString(new Date(year, month-1, 25)),
				label: Constants.PaymentFrequencyDates[month-1].name + '-' + (year).toString().slice(2)
			});
		}
		return dates;
	}
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/PensionPaymentHelper.js